import { useNavigate } from "react-router-dom";
import DownloadIcon from "@mui/icons-material/Download";
import { Button } from "@mui/material";
import IfCan from "../../../components/IfCan";
import {
    ResponsiveContainer,
    Tooltip,
    BarChart,
    CartesianGrid,
    XAxis,
    YAxis,
    Bar,
    PieChart,
    Pie,
    Cell,
    Legend,
    LineChart,
    Line,
} from "recharts";
import MainContainer from "../../../layout/MainContainer";

const COLORS = ["#0088FE", "#FF8042", "#FF6384", "#4BC0C0", "#00C49F"];

// Chart Data
const revenueByPlan = [
    { name: "Free", value: 3000 },
    { name: "Premium", value: 12000 },
];

const refundsIssued = [
    { name: "Mon", count: 2 },
    { name: "Tue", count: 1 },
    { name: "Wed", count: 3 },
    { name: "Thu", count: 0 },
    { name: "Fri", count: 2 },
    { name: "Sat", count: 1 },
    { name: "Sun", count: 4 },
];

const avgSpendData = [
    { name: "User 1", value: 350 },
    { name: "User 2", value: 420 },
    { name: "User 3", value: 280 },
    { name: "User 4", value: 500 },
    { name: "User 5", value: 390 },
];

const breachedCategories = [
    { name: "Food", count: 20 },
    { name: "Travel", count: 15 },
    { name: "Shopping", count: 25 },
    { name: "Entertainment", count: 10 },
];

const FinancialOverview = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="main_title d_flex">
                <div className="left_s">
                    <h1>Financial Overview</h1>
                    <p>
                        <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Financial Overview
                    </p>
                </div>
                <div className="right_s">
                    <IfCan module="Manage Analytics" action="add_edit">
                        <Button className="btn btn_primary">
                            <DownloadIcon /> Export
                        </Button>
                    </IfCan>
                </div>
            </div>

            <div className="grid_sc gap_m">

                {/* 1. Revenue by Plan */}
                <div className="cards table_card">
                    <div className="cards_header">
                        <div className="left_s">
                            <h2>Revenue by Plan</h2>
                        </div>
                        <div className="right_s">
                            <p>
                                <span>A day</span>
                                <span>A week</span>
                                <span>A month</span>
                                <span>A year</span>
                            </p>
                        </div>
                    </div>
                    <ResponsiveContainer width="100%" height={300}>
                        <PieChart>
                            <Pie
                                data={revenueByPlan}
                                dataKey="value"
                                nameKey="name"
                                cx="50%"
                                cy="50%"
                                outerRadius={100}
                                label
                            >
                                {revenueByPlan.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                ))}
                            </Pie>
                            <Tooltip />
                            <Legend />
                        </PieChart>
                    </ResponsiveContainer>
                </div>

                {/* 2. Refunds Issued */}
                <div className="cards table_card">
                    <div className="cards_header">
                        <div className="left_s">
                            <h2>Refunds Issued</h2>
                        </div>
                        <div className="right_s">
                            <p>
                                <span>A day</span>
                                <span>A week</span>
                                <span>A month</span>
                                <span>A year</span>
                            </p>
                        </div>
                    </div>
                    <ResponsiveContainer width="100%" height={300}>
                        <BarChart data={refundsIssued}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            <Bar dataKey="count" fill="#FF6384" />
                        </BarChart>
                    </ResponsiveContainer>
                </div>

                {/* 3. Average Spend Tracked Per User */}
                <div className="cards table_card">
                    <div className="cards_header">
                        <div className="left_s">
                            <h2>Average Spend Tracked per User</h2>
                        </div>
                        <div className="right_s">
                            <p>
                                <span>A day</span>
                                <span>A week</span>
                                <span>A month</span>
                                <span>A year</span>
                            </p>
                        </div>
                    </div>
                    <ResponsiveContainer width="100%" height={300}>
                        <BarChart data={avgSpendData}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            <Bar dataKey="value" fill="#4BC0C0" />
                        </BarChart>
                    </ResponsiveContainer>
                </div>

                {/* 4. Budget Category Most Breached */}
                <div className="cards table_card">
                    <div className="cards_header">
                        <div className="left_s">
                            <h2>Most Breached Budget Category</h2>
                        </div>
                        <div className="right_s">
                            <p>
                                <span>A day</span>
                                <span>A week</span>
                                <span>A month</span>
                                <span>A year</span>
                            </p>
                        </div>
                    </div>
                    <ResponsiveContainer width="100%" height={300}>
                        <BarChart data={breachedCategories}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            <Bar dataKey="count">
                                {breachedCategories.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                ))}
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                </div>

            </div>
        </>
    );
};

export default FinancialOverview;
